/**
 * @function LoadingSpinner
 * @description Functional component containing single div element with spinner class
 * @returns {JSX} Markup for the loading spinner component
 */
const LoadingSpinner = () => {
    return <div className="spinner"></div>;
};

export default LoadingSpinner;
